import { BaseTableEditorStore } from '@/tableDefinitionEditor/baseTableEditorStore';
import { ColumnDefinition } from '@/tableDefinitionEditor/tableDefinition.types';
import { sqScalingTableDefinitionStore } from '@/core/core.stores';

/**
 * Store for the scaling table definition editor
 * Table definition state is not stored in worksteps, so we separate the logic of what table is being looked at
 * here, which is stored in the workstep, while the table definition state is stored in the table definition store
 * which is updated when we receive messages from the server on the socket for table definitions.
 * The corresponding actions file will be the templated tableDefinitionEditor.actions file.
 * The base TableDefinitionEditorStore class contains all handler functions, getters and state management
 */
export class ScalingTableEditorStore extends BaseTableEditorStore {
  static readonly storeName = 'sqScalingTableEditorStore';

  get columnToEdit(): ColumnDefinition | undefined {
    return this.getColumnToEdit({
      columnToEditId: this.columnToEditId,
      existingColumns: sqScalingTableDefinitionStore.columns,
    });
  }

  override handlers = {
    SCALING_SET_TABLE_ID: this.setTableId,
    SCALING_RESET_TABLE_EDITOR_STORE: this.reset,
    SCALING_SET_SHOW_CONFIGURE_SEARCH: this.setShowConfigureSearch,
    SCALING_SET_COLUMN_TO_EDIT_ID: this.setColumnToEditId,
    SCALING_SET_SHOW_COLUMN_PROPERTIES: this.setShowColumnProperties,
    SCALING_SET_ENABLE_TREE_CREATION: this.setEnableTreeCreation,
    SCALING_SET_SELECTED_COLUMN_OPTION: this.setSelectedColumnOption,
    SCALING_SET_SHORTCUT_SOURCE_COLUMN: this.setShortcutSourceColumn,
    SCALING_SET_INCLUDE_HIERARCHY: this.setIncludeHierarchy,
    SCALING_SET_CONTROL_PANE: this.setControlPane,
  };
}
